import type { BatMetadataConfigEntry } from './common/types';
import { coreFields } from './common/coreFields';
import { massUnitField } from './common/sharedFields';
import { locationFields } from './common/locationFields';
import { vendorFields } from './common/vendorFields';
import { productFields } from './common/productFields';
import { wasteFields, wasteQuantityField } from './common/wasteFields';
import { msg } from '@lingui/core/macro';
import { buildingDisplayNameField } from './common/buildingCommonFields';

export const wasteMetadata = {
  displayName: msg({
    message: 'Waste',
    context: 'Activity data schema name for waste',
  }),
  fields: {
    ...coreFields,
    ...locationFields,
    ...vendorFields,
    ...productFields,
    ...wasteFields,
    building_display_name: buildingDisplayNameField,
    quantity: wasteQuantityField,
    unit: massUnitField,
  },
} as const satisfies BatMetadataConfigEntry;
